import { render, staticRenderFns } from "./AssetFilters.vue?vue&type=template&id=01ff5899&scoped=true"
import script from "./AssetFilters.vue?vue&type=script&lang=js"
export * from "./AssetFilters.vue?vue&type=script&lang=js"
import style0 from "./AssetFilters.vue?vue&type=style&index=0&id=01ff5899&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ff5899",
  null
  
)

export default component.exports